// this component provides a image selection button, which when clicked should open a filepicker instance which will upload a image and return the location.

import React from 'react';
import PropTypes from 'prop-types';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import { filePickerHelper } from 'app-lib/helpers/filepicker';
import config from 'config';

export class ImageSelector extends React.Component {
    constructor(props) {
        super(props);
    }

    openFilePicker(e) {
        e.stopPropagation();
        const self = this;
        const filePickerOptions = {
            fileType: 'thumbnails',
            extension: ['.jpg', '.jpeg', '.png'],
            cropRatio: 16 / 9,
            imageMin: [300, 170],
            customText: config.filepicker.thumbnail.customText,
            customCss: config.filepicker.thumbnail.customCss
        };
        filePickerHelper.pickAndStore(filePickerOptions, (thumbnailUrl, Blobs) => {
            self.props.clickHandler(thumbnailUrl, Blobs);
        });
    }

    render() {
        const {t, details} = this.props;
        let element = null;
        const tooltip = (
            <Tooltip className="thumbnail-icon-tooltip" id="tooltip"><strong>{t('CatalogCard.add-thumbnail')}</strong></Tooltip>
        );
        if (!this.props.show) {
            return null;
        }

        const tooltipRemove = (
            <Tooltip className="thumbnail-icon-tooltip" id="tooltip"><strong>{t('CatalogCard.remove-thumbnail')}</strong></Tooltip>
        );

        const removeThumbnail = (<OverlayTrigger placement="bottom" overlay={tooltipRemove}>
            <div
              className="image-select-icon" id={`thumb-${details.id}`} onClick={this.props.deleteThumbnail.bind(this, details.id)}
            >
                <img
                  src={`${config.assets.url}/images/catalog/remove-thumbnail.png`}
                  alt="remove thumbnail"
                  className="thumbnail-icon_remove"
                />
            </div>
        </OverlayTrigger>);

        const addThumbnail = (<OverlayTrigger placement="bottom" overlay={tooltip}>
            <div className="image-select-icon" onClick={this.openFilePicker.bind(this)}>
                <i className="material-icons image-select-icon__icon-adjust">photo</i>
            </div>
        </OverlayTrigger>);

        if (details.thumbnail) {
            element = removeThumbnail;
        } else if (details.defaultThumbnail) {
            if (details.defaultThumbnail.exist) {
                element = removeThumbnail;
            } else {
                element = addThumbnail;
            }
        } else {
            element = addThumbnail;
        }

        return element;
    }
}
ImageSelector.propTypes = {
    t: PropTypes.func,
    show: PropTypes.bool,
    details: PropTypes.object,
    deleteThumbnail: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/image-selector.js